const LSCReportingNavLinks = {
  LSC_REPORTING_ROOT: '/lscreporting',
  LSC_REPORTING_SELECTION: '/lscreporting/selection',
  LSC_REPORTING_REPORTS: '/lscreporting/reports',
  LSC_REPORTING_HQ_SELECTION: '/lscreporting/hqselection',
  LSC_REPORTING_HQ_REPORTS: '/lscreporting/hqreports'
};

export default LSCReportingNavLinks;